<div class="deadline-footer">
    <div (click)="openModal()" role="button" class="row m-auto">
        @for (
            section of footerSections | filter: filterSections | sortBy: 'asc' : deadlineDate;
            track $index;
            let i = $index
        ) {
            <div class="col-lg-4 text-center footer-section">
                <strong
                    class="activity-deadline"
                    [popover]="deadlinePopover"
                    triggers="mouseenter:mouseleave"
                    [placement]="getPlacement(i)"
                    (mouseenter)="setPopoverContent(section)"
                >
                    <small>{{ getDeadlineLabel(section.deadlineType) }}: {{ section.date }}</small>
                </strong>
            </div>
        }
    </div>
    @if (footerSections?.length > 3) {
        <div style="position: absolute; right: 5px; bottom: 3px">
            <button class="ace-btn has-icon btn-secondary" style="margin: 0" (click)="changeRow()">
                @if (onRow === 0) {
                    <i class="fa fa-chevron-down"></i>
                }
                @if (onRow === 1) {
                    <i class="fa fa-chevron-up"></i>
                }
            </button>
        </div>
    }
</div>

<ng-template #deadlinePopover>
    <table class="deadline-popover">
        <thead>
            <tr>
                <th class="text-start">Acct #</th>
                <th class="text-start">Year</th>
                <th class="text-start">{{ popoverContent.label }}</th>
            </tr>
        </thead>
        @for (parcelData of popoverContent.data.parcels; track $index) {
            <tbody>
                @for (yearData of parcelData.years; track $index; let i = $index) {
                    <tr>
                        @if (i === 0) {
                            <td [attr.rowspan]="parcelData.years.length">
                                <small>{{ parcelData.acctNum }}</small>
                            </td>
                        }
                        <td>
                            <small>{{ yearData.annualYear }}</small>
                        </td>
                        <td>
                            <small>{{ getValue(yearData) }}</small>
                        </td>
                    </tr>
                }
            </tbody>
        }
    </table>
</ng-template>
